import { DeviceTaskType } from "../IDevice";
import { DeviceControlFeature } from "../IDeviceTask";
import { DeviceTask } from "./DeviceTask";
export class SetTemperature extends DeviceTask {
    constructor() {
        super();
        this.Temperature = 0;
        this.FeatureType = DeviceControlFeature.SetTemperature;
        this.TaskType = DeviceTaskType.SetTemperature;
    }
}
export class TurnOff extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.TurnOff;
        this.TaskType = DeviceTaskType.TurnOff;
    }
}
export class TurnOn extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.TurnOn;
        this.TaskType = DeviceTaskType.TurnOn;
    }
}
export class TurnOnWithTime extends DeviceTask {
    constructor() {
        super();
        this.SwitchOffDelaySeconds = 0;
        this.FeatureType = DeviceControlFeature.TurnOnWithTimeout;
        this.TaskType = DeviceTaskType.TurnOnWithTime;
    }
}
export class SetLightBrightness extends DeviceTask {
    constructor() {
        super();
        this.Brightness = 0;
        this.FeatureType = DeviceControlFeature.SetLightBrightness;
        this.TaskType = DeviceTaskType.SetLightBrightness;
    }
}
export class ToggleState extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.ToggleState;
        this.TaskType = DeviceTaskType.TogleState;
    }
}
export class SetLightColor extends DeviceTask {
    constructor() {
        super();
        this.R = 0;
        this.G = 0;
        this.B = 0;
        this.FeatureType = DeviceControlFeature.SetLightColor;
        this.TaskType = DeviceTaskType.SetLightColor;
    }
}
export class SetLightTemperature extends DeviceTask {
    constructor() {
        super();
        this.Temperature = 0;
        this.FeatureType = DeviceControlFeature.SetLightTemperature;
        this.TaskType = DeviceTaskType.SetLightTemperature;
    }
}
export class SetBlindPosition extends DeviceTask {
    constructor() {
        super();
        this.Action = BlindActionEnum.Stop;
        this.Position = 0;
        this.FeatureType = DeviceControlFeature.SetBlindPosition;
        this.TaskType = DeviceTaskType.SetBlindPosition;
    }
}
export var BlindActionEnum;
(function (BlindActionEnum) {
    BlindActionEnum[BlindActionEnum["Open"] = 0] = "Open";
    BlindActionEnum[BlindActionEnum["Close"] = 1] = "Close";
    BlindActionEnum[BlindActionEnum["Stop"] = 2] = "Stop";
    BlindActionEnum[BlindActionEnum["Percentage"] = 3] = "Percentage";
})(BlindActionEnum || (BlindActionEnum = {}));
export class SetGatePositionPrecise extends DeviceTask {
    constructor() {
        super();
        this.GateControlAction = GateActionEnum.Stop;
        this.Position = 0;
        this.FeatureType = DeviceControlFeature.SetGatePositionPrecise;
        this.TaskType = DeviceTaskType.PreciseGateControl;
    }
}
export class SetGatePositionPreciseSecure extends DeviceTask {
    constructor() {
        super();
        this.GateControlAction = GateActionEnum.Stop;
        this.Position = 0;
        this.Pin = "";
        this.FeatureType = DeviceControlFeature.SetGatePositionPreciseSecure;
        this.TaskType = DeviceTaskType.PreciseGateControlSecure;
    }
}
export var GateActionEnum;
(function (GateActionEnum) {
    GateActionEnum[GateActionEnum["Open"] = 0] = "Open";
    GateActionEnum[GateActionEnum["Close"] = 1] = "Close";
    GateActionEnum[GateActionEnum["Stop"] = 2] = "Stop";
    GateActionEnum[GateActionEnum["Percentage"] = 3] = "Percentage";
})(GateActionEnum || (GateActionEnum = {}));
export class SetBlindPositionSimple extends DeviceTask {
    constructor() {
        super();
        this.Action = BlindActionSimpleEnum.Stop;
        this.Position = 0;
        this.FeatureType = DeviceControlFeature.SetBlindPosition;
        this.TaskType = DeviceTaskType.SetBlindPositionSimple;
    }
}
export var BlindActionSimpleEnum;
(function (BlindActionSimpleEnum) {
    BlindActionSimpleEnum[BlindActionSimpleEnum["Open"] = 0] = "Open";
    BlindActionSimpleEnum[BlindActionSimpleEnum["Close"] = 1] = "Close";
    BlindActionSimpleEnum[BlindActionSimpleEnum["Stop"] = 2] = "Stop";
})(BlindActionSimpleEnum || (BlindActionSimpleEnum = {}));
export class SetLightBrightnessDynamicly extends DeviceTask {
    constructor() {
        super();
        this.Brightness = 0;
        this.FeatureType = DeviceControlFeature.SetLightBrightnessDynamicly;
        this.TaskType = DeviceTaskType.SetLightBrightnessDynamicly;
    }
}
export class IdentifyDevice extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.IdentifyDevice;
        this.TaskType = DeviceTaskType.IdentifyDevice;
    }
}
export class SetBlindOpenCloseTime extends DeviceTask {
    constructor() {
        super();
        this.Data = new BlindOpenCloseTimeData();
        this.FeatureType = DeviceControlFeature.SetBlindOpenCloseTime;
        this.TaskType = DeviceTaskType.SetBlindOpenCloseTime;
    }
}
export class BlindOpenCloseTimeData {
    constructor() {
        this.Channel = 0;
        this.CloseTime = 0;
        this.OpenTime = 0;
    }
}
export class GetDeviceState extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.GetState;
        this.TaskType = DeviceTaskType.GetChannelsState;
    }
}
export class SetBlindMicroventilation extends DeviceTask {
    constructor() {
        super();
        this.Position = 0;
        this.FeatureType = DeviceControlFeature.SetBlindMicroventilation;
        this.TaskType = DeviceTaskType.SetBlindMicroventilation;
    }
}
export class ChangeGatePositionPulse extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.GatePulse;
        this.TaskType = DeviceTaskType.ChangeGatewayPositionPulse;
    }
}
export class ChangeGatewayPositionPulse extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.GatewayPulse;
        this.TaskType = DeviceTaskType.ChangeGatewayPositionPulse;
    }
}
export class SetFacadePosition extends DeviceTask {
    constructor() {
        super();
        this.FacadeAction = FacadeActionEnum.Stop;
        this.Tilt = 0;
        this.Position = 0;
        this.FeatureType = DeviceControlFeature.SetFacadePositionAndTilt;
        this.TaskType = DeviceTaskType.SetFacadePosition;
    }
}
export class GetFacadeType extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.GetFacadeType;
        this.TaskType = DeviceTaskType.GetFacadeType;
    }
}
export var FacadeActionEnum;
(function (FacadeActionEnum) {
    FacadeActionEnum[FacadeActionEnum["Open"] = 0] = "Open";
    FacadeActionEnum[FacadeActionEnum["Close"] = 1] = "Close";
    FacadeActionEnum[FacadeActionEnum["Stop"] = 2] = "Stop";
    FacadeActionEnum[FacadeActionEnum["Percentage"] = 3] = "Percentage";
    FacadeActionEnum[FacadeActionEnum["Tilt"] = 4] = "Tilt";
    FacadeActionEnum[FacadeActionEnum["TiltAndPercentage"] = 5] = "TiltAndPercentage";
})(FacadeActionEnum || (FacadeActionEnum = {}));
export class LightRGBWData {
    constructor() {
        this.R = 0;
        this.G = 0;
        this.B = 0;
        this.W = 0;
        this.Brightness = 0;
        this.Channel = 0;
    }
}
export class LightRGBW extends DeviceTask {
    constructor() {
        super();
        this.Data = new LightRGBWData();
        this.FeatureType = DeviceControlFeature.LightRGBW;
        this.TaskType = DeviceTaskType.LightRGBW;
    }
}
//# sourceMappingURL=Tasks.js.map